import "core-js/modules/es.function.bind";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.string.link";
import "core-js/modules/web.timers";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";

var _a;

import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import store from '@/store/index';
import { dateNow, dateFormat } from '@/lib/utils';
import QrcodePopup from '@/components/popup/qrcodePopup.vue';
import DistrictPicker from '@/features/district/districtPicker.vue';
import { ROUTE_NAME, datePopup } from '@/lib/constant';
import WechatPopup from '@/components/activity/wechatPopup.vue';

var App =
/** @class */
function (_super) {
  __extends(App, _super);

  function App() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.topVisiable = false;
    _this.scroll = true;
    _this.show = false;
    _this.show1 = false;
    _this.show1Option = {
      link: '',
      image: ''
    };
    /** 跳转到某活动id */

    _this.activityId = '26';
    return _this;
  }

  Object.defineProperty(App.prototype, "requesting", {
    /** 请求提示数量 */
    get: function get() {
      return store.state.util.requesting;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(App.prototype, "errorCount", {
    /** 错误提示数量 */
    get: function get() {
      return store.state.error.errorCount;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(App.prototype, "errorInfo", {
    /** 错误信息 */
    get: function get() {
      return store.state.error.errorInfo || {
        type: 'icon',
        icon: '&#xe621;',
        text: '发生了一些错误'
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(App.prototype, "indicatorVisible", {
    /** 提示是否可见 */
    get: function get() {
      return this.requesting + this.errorCount > 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(App.prototype, "district", {
    /** 地址是否可见 */
    get: function get() {
      return store.state.util.district;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(App.prototype, "countdownImage", {
    /** 倒计时显示的弹窗图片内容 */
    get: function get() {
      var key = dateFormat(dateNow());
      return datePopup[key];
    },
    enumerable: false,
    configurable: true
  });

  App.prototype.onDistrictUpdate = function (names, ids) {
    if (this.district.update) {
      this.district.update(names, ids);
    }
  };

  App.prototype.onDistrictFinish = function () {
    if (this.district.finish) {
      this.district.finish();
    }
  };
  /**
   * 更换套餐
   */


  App.prototype.onClickChangePackage = function () {
    this.show = false;
    this.$router.push({
      name: ROUTE_NAME.ACTIVITY_EQUIPMENT,
      params: {
        activityId: this.activityId
      },
      query: {
        changePackage: '1'
      }
    });
  };

  App.prototype.onClickChangePackage1 = function () {
    this.show1 = false;

    if (this.show1Option.link) {
      location.href = this.show1Option.link;
    }
  };

  App.prototype.scrollCallback = function () {
    if (!this.scroll) {
      return;
    }

    var scroll_top = window.pageYOffset || document.documentElement.scrollTop;

    if (scroll_top > window.innerHeight * 2.3) {
      this.topVisiable = true;
    } else {
      this.topVisiable = false;
    }

    return true;
  };
  /** 点击回到顶部 */


  App.prototype.onClickGoTop = function () {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  App.prototype.mounted = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        store.commit('addScrollCallback', this.scrollCallback.bind(this)); // const LocationShowName = get('SHOWPACKAGECHANGE')
        // if (isUndef(LocationShowName)) {
        //     setTimeout(async () => {
        //         const rdata = await store.dispatch('participation/getShowAlert');
        //         if (rdata.status === 0) {
        //             const show = rdata.data;
        //             this.show = show;
        //             if (show) {
        //                 set('SHOWPACKAGECHANGE', this.activityId);
        //             }
        //         }
        //     }, 1000);
        // }

        setTimeout(function () {
          return __awaiter(_this, void 0, void 0, function () {
            var rdata;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  return [4
                  /*yield*/
                  , store.dispatch('user/getUserAlert')];

                case 1:
                  rdata = _a.sent();

                  if (rdata.data && rdata.status === 0) {
                    this.show1Option = rdata.data;
                    this.show1 = true;
                  }

                  return [2
                  /*return*/
                  ];
              }
            });
          });
        }, 1000);
        return [2
        /*return*/
        ];
      });
    });
  };

  App.prototype.beforeDestroy = function () {
    this.scroll = false;
  };

  App = __decorate([Component({
    name: 'App',
    components: (_a = {
      QrcodePopup: QrcodePopup,
      DistrictPicker: DistrictPicker
    }, _a[_Dialog.Component.name] = _Dialog.Component, _a.WechatPopup = WechatPopup, _a)
  })], App);
  return App;
}(Vue);

export default App;